"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/* eslint-disable max-len */

/**
 * useHistoryState is a custom hook for managing browser history and state updates.
 *
 * @param {any} defaultState The default state to be used for the component.
 * @param {boolean} [useReplaceState=false] Optional. If true, uses window.history.replaceState to update the history instead of window.history.pushState.
 * @returns {[any, function]} A tuple with current state, a update state function and add a new entry to the browser history.
 *
 * @example
 * import React from 'react';
 * import useHistoryState from './useHistoryState';
 *
 * function ExampleComponent() {
 *   const [exampleState, updateExampleState] = useHistoryState('initialState');
 *   // const [exampleState, updateExampleState] = useHistoryState('initialState', true);
 *
 *   const handleStateUpdate = () => {
 *     updateExampleState('newState');
 *   };
 *
 *   return (
 *     <div>
 *       <button onClick={handleStateUpdate}>Update State</button>
 *     </div>
 *   );
 * }
 */

function useHistoryState(defaultState, useReplaceState = false) {
  const [state, setState] = (0, _react.useState)(defaultState);
  const updateStateAndAddToHistory = newState => {
    setState(newState);
    const historyMethod = useReplaceState ? 'replaceState' : 'pushState';
    window.history[historyMethod]({
      state: newState
    }, '', window.location.href);
  };
  const handlePopState = () => {
    if (window.history.state && window.history.state.state) {
      setState(window.history.state.state);
    }
  };
  (0, _react.useEffect)(() => {
    window.addEventListener('popstate', handlePopState);

    // Handle the initial state when the component loads
    const initialStateFromHistory = window.history.state && window.history.state.state;
    if (initialStateFromHistory) {
      setState(initialStateFromHistory);
    }
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  return [state, updateStateAndAddToHistory];
}
var _default = exports.default = useHistoryState;